import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

export default function NewsDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setError("Post not found"));
  }, [slug]);

  if (error)
    return (
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-20 text-neutral-400" data-testid="news-detail-error">
        {error}
        <div className="mt-4">
          <Link to="/news" className="text-axe-purple underline">Back to news</Link>
        </div>
      </div>
    );
  if (!post)
    return (
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-20 text-neutral-400" data-testid="news-detail-loading">
        Loading…
      </div>
    );

  const date = new Date(post.published_at).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <article className="max-w-4xl mx-auto px-5 md:px-8 pt-12 md:pt-16 text-white" data-testid="news-detail">
      <Link
        to="/news"
        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-bold text-axe-purple hover:text-white"
      >
        <ArrowLeft size={14} /> All news
      </Link>

      <div className="mt-8 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em]">
        <span className="px-3 py-1 rounded-full bg-axe-tangerine text-black font-bold">
          {post.tag}
        </span>
        <span className="text-neutral-500">{date}</span>
      </div>

      <h1 className="mt-5 font-display font-black text-3xl sm:text-5xl leading-[1.08]">
        {post.title}
      </h1>

      <div className="mt-8 overflow-hidden rounded-2xl border border-axe-border">
        <img src={post.image} alt="" className="w-full h-auto object-cover aspect-[16/9]" />
      </div>

      <div className="mt-10 text-lg leading-relaxed text-neutral-300 whitespace-pre-line">
        {post.content}
      </div>

      <div className="mt-12 text-xs uppercase tracking-[0.3em] text-neutral-500">
        By {post.author}
      </div>
    </article>
  );
}
